export const TA = 1;
export const TA_PRO = 2;
export const FULL = 3;
